/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeadWaitlistDetails
 */
export interface LeadWaitlistDetails {
    /**
     * 
     * @type {string}
     * @memberof LeadWaitlistDetails
     */
    status_set_date?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadWaitlistDetails
     */
    status_set_reason?: string;
}

/**
 * Check if a given object implements the LeadWaitlistDetails interface.
 */
export function instanceOfLeadWaitlistDetails(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function LeadWaitlistDetailsFromJSON(json: any): LeadWaitlistDetails {
    return LeadWaitlistDetailsFromJSONTyped(json, false);
}

export function LeadWaitlistDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadWaitlistDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status_set_date': !exists(json, 'status_set_date') ? undefined : json['status_set_date'],
        'status_set_reason': !exists(json, 'status_set_reason') ? undefined : json['status_set_reason'],
    };
}

export function LeadWaitlistDetailsToJSON(value?: LeadWaitlistDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status_set_date': value.status_set_date,
        'status_set_reason': value.status_set_reason,
    };
}

